export const DSCP_FLOWS = [
  {
    value: 'Best effort',
    id: 0
  },
  {
    value: '1',
    id: 1
  },
  {
    value: '2',
    id: 2
  },
  {
    value: '3',
    id: 3
  },
  {
    value: '4',
    id: 4
  },
  {
    value: '5',
    id: 5
  },
  {
    value: '6',
    id: 6
  },
  {
    value: '7',
    id: 7
  },
  {
    value: 'Class Selector 1',
    id: 8
  },
  {
    value: '9',
    id: 9
  },
  {
    value: 'AF 11',
    id: 10
  },
  {
    value: '11',
    id: 11
  },
  {
    value: 'AF 12',
    id: 12
  },
  {
    value: '13',
    id: 13
  },
  {
    value: 'AF 13',
    id: 14
  },
  {
    value: '15',
    id: 15
  },
  {
    value: 'Class Selector 2',
    id: 16
  },
  {
    value: '17',
    id: 17
  },
  {
    value: 'AF 21',
    id: 18
  },
  {
    value: '19',
    id: 19
  },
  {
    value: 'AF 22',
    id: 20
  },
  {
    value: '21',
    id: 21
  },
  {
    value: 'AF 23',
    id: 22
  },
  {
    value: '23',
    id: 23
  },
  {
    value: 'Class Selector 3',
    id: 24
  },
  {
    value: '25',
    id: 25
  },
  {
    value: 'AF 31',
    id: 26
  },
  {
    value: '27',
    id: 27
  },
  {
    value: 'AF 32',
    id: 28
  },
  {
    value: '29',
    id: 29
  },
  {
    value: 'AF 33',
    id: 30
  },
  {
    value: '31',
    id: 31
  },
  {
    value: 'Class Selector 4',
    id: 32
  },
  {
    value: '33',
    id: 33
  },
  {
    value: 'AF 41',
    id: 34
  },
  {
    value: '35',
    id: 35
  },
  {
    value: 'AF 42',
    id: 36
  },
  {
    value: '37',
    id: 37
  },
  {
    value: 'AF 43',
    id: 38
  },
  {
    value: '39',
    id: 39
  },
  {
    value: 'Class Selector 5',
    id: 40
  },
  {
    value: '41',
    id: 41
  },
  {
    value: 'AF 51',
    id: 42
  },
  {
    value: '43',
    id: 43
  },
  {
    value: 'AF 52',
    id: 44
  },
  {
    value: '45',
    id: 45
  },
  {
    value: 'Exp. Forwarding',
    id: 46
  },
  {
    value: '47',
    id: 47
  },
  {
    value: 'Class Selector 6',
    id: 48
  },
  {
    value: '49',
    id: 49
  },
  {
    value: '50',
    id: 50
  },
  {
    value: '51',
    id: 51
  },
  {
    value: '52',
    id: 52
  },
  {
    value: '53',
    id: 53
  },
  {
    value: '54',
    id: 54
  },
  {
    value: '55',
    id: 55
  },
  {
    value: 'Class Selector 7',
    id: 56
  },
  {
    value: '57',
    id: 57
  },
  {
    value: '58',
    id: 58
  },
  {
    value: '59',
    id: 59
  },
  {
    value: '60',
    id: 60
  },
  {
    value: '61',
    id: 61
  },
  {
    value: '62',
    id: 62
  },
  {
    value: '63',
    id: 63
  }
];

export const TX_INTERVAL = [
  {
    value: '10 ms',
    id: 10
  },
  {
    value: '20 ms',
    id: 20
  },
  {
    value: '100 ms',
    id: 100
  },
  {
    value: '1 s',
    id: 1000
  },
  {
    value: '2 s',
    id: 2000
  }
];
export const PM_INTERVAL = [
  {
    value: '1 minute',
    id: 60
  },
  {
    value: '5 minutes',
    id: 300
  },
  {
    value: '15 minutes',
    id: 900
  }
];
export interface DSCP_FLOWS_TYPE {
  id?: number;
  value?: string;
  checked?: boolean;
  frameSize?: number;
  txInterval?: string;
  padding?: number;
}

export const MOS_CODEC_CONFIG = [
  {
    id: 'none',
    value: 'None'
  },
  {
    id: 'G.711_64_kbps',
    value: 'G.711 64kb/s'
  },
  {
    id: 'G.723.1_5.3_kbps',
    value: 'G.723.1 5.3 kb/s'
  },
  {
    id: 'G.726_24_kbps',
    value: 'G.726 24 kb/s'
  },
  {
    id: 'G.729_8_kbps',
    value: 'G.729 8 kb/s'
  },
  {
    id: 'generic',
    value: 'Generic'
  }
];
export enum MOS_CONFIG {
  NONE = 'none',
  GENERIC = 'generic'
}
